if (!customElements.get('product-simple-pack-bundle-form')) {
  customElements.define('product-simple-pack-bundle-form', class ProductSimplePackBundleForm extends HTMLElement {
    constructor() {
      super();
      this.productAquantity = +this.dataset.packaquantity;
      this.productXquantity = +this.dataset.packxquantity;
      this.secondEnabled = this.dataset.secondenabled;
      this.totalQquantity = (this.productAquantity + this.productXquantity);
      
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.quantityButtons = this.querySelectorAll(".quantity-button");
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.quantityInputs = this.querySelectorAll(".custom-qty-box-input");
      
      this.initEventListeners();
    }
    initEventListeners(){
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.quantityButtons.forEach( (el) => {
        el.addEventListener("click",this.quantityChangeHandler.bind(this));
      });
    }
    
    connectedCallback() {
       
    }
    quantityChangeHandler(evt){
      evt.preventDefault();
      let quantity = 0;
      this.quantityInputs.forEach((el)=>{
         if(el.classList.contains('active')){
           const selectedQty = +el.dataset.quantity;
           quantity = quantity + selectedQty;
         }
      });
     if(quantity >= this.totalQquantity){
       this.submitButton.querySelector("span.bundle-message").classList.add("hidden");
       this.submitButton.querySelector("span.add-to-cart-message").classList.remove("hidden");
       this.submitButton.removeAttribute("disabled");
       
     }else{
       this.submitButton.querySelector("span.add-to-cart-message").classList.add("hidden");
       this.submitButton.querySelector("span.bundle-message").classList.remove("hidden");
       this.submitButton.setAttribute("disabled","disabled");
     }
      
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if(this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").length <= 0){
        return false;
      }
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const mainId = this.form.querySelector(`input[name="id"]`).value;
      const bundleId = new Date().getTime();
      const allproperties = [];
      let items = [];
      
      let bundlerItem = 0;
      this.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input.active").forEach( (el) => {
        if(el.value > 0){
          allproperties.push(el.dataset.title);
            items.push({
              "id":el.dataset.vid,
              "quantity":el.value,
              "properties":{
                "_customBundleId":bundleId,
                "_isMainProduct":0,
                "_baseQty":el.value
              }
            });
          bundlerItem++;
        }
      });
      items.push(
        {
          "id":mainId,
          "quantity":1,
          "properties":{
            "_customBundleId":bundleId,
            "_isMainProduct":1,
            "BundleItems":allproperties.join("|")
          }
        }
      );
      if(bundlerItem <= 0){
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.setAttribute("disabled","disabled");
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return false;
      }
      let formData = {
       'items':items,
        'sections':this.cart.getSectionsToRender().map((section) => section.id),
        'sections_url':window.location.pathname
      };
      fetch(`${routes.cart_add_url}.js`,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: mainId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: mainId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.closest(".custom-modal__centered.active").classList.remove("active");
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}